import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CoreModule } from "../core/core.module";
import { EmailsListingComponent } from "./emails-listing/emails-listing.component";
import { EmailsService } from "./services/emails.service";
import { AgmCoreModule } from "@agm/core";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyAhwtYnaefUYn16x7B1dFjHy4WMv6KALTY",
    }),
    RouterModule,
  ],
  exports: [EmailsListingComponent],
  providers: [EmailsService],
  declarations: [EmailsListingComponent],
})
export class EmailsModule {}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/emails/emails.module.ts